import box from './box.png'
import { fullVHExceptHeader } from 'pobble-components/dist/jss-mixins'

const styles = ({ FONT_SIZES }) => ({
  container: {
    ...fullVHExceptHeader,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  box: {
    width: '350px',
    height: '350px',
    backgroundSize: 'contain',
    backgroundImage: `url(${box})`
  },
  title: {
    fontSize: '30px',
    lineHeight: '34px',
    margin: '0 0 20px',
    fontWeight: 'bold'
  },
  desc: {
    ...FONT_SIZES.BODY_LARGE.STYLE,
    margin: '0 0 30px'
  }
})

export default styles
